/** @typedef {import('../types/models').Wallet} Wallet */
/** @typedef {import('../types/models').Currency} Currency */
/** @typedef {import('../types/api').ApiResponse} ApiResponse */

import { instance } from '../config/api';

/** @returns {Promise<ApiResponse<Wallet[]>>} */
const fetchWallets = async () => {
  const { data } = await instance.get('wallet');
  return data;
};

/**
 * @param {string} [type] - Filter by currency type ('FIAT' | 'CRYPTO')
 * @returns {Promise<(Currency & { value: number })[]>}
 */
const fetchCurrencies = async (type) => {
  const query = `currency${type ? `?type=${type}` : ''}`;
  const { data } = await instance.get(query);
  if (data.data) {
    const currencies = data.data.map((currency) => {
      const { id } = currency;
      return {
        value: id,
        ...currency
      };
    });

    return currencies;
  }
  return data;
};
export { fetchCurrencies, fetchWallets };
